import { updateChatFormInputHeight } from "./updateChatFormInputHeight";
import { syncContentGeneratorPoseThumbnails } from "../components/contentGeneratorPoseThumbnails";
import { openSettingsModalTab } from "../components/chatSettingsModalNavigation";

let inlineGeneratorPromise = null;

function ensureInlineGenerator() {
  if ($(".content-generator-settings-inner").length) {
    return Promise.resolve();
  }

  if (inlineGeneratorPromise) {
    return inlineGeneratorPromise;
  }

  const placeholder = $(".content-generator-settings-placeholder").first();
  const action = window.growtype_chat_ajax?.get_inline_generator_action ||
    "growtype_chat_get_inline_generator";
  if (!placeholder.length || !action) {
    return Promise.reject(new Error("Inline content generator is unavailable."));
  }

  inlineGeneratorPromise = new Promise((resolve, reject) => {
    $.ajax({
      url: growtype_chat_ajax.url,
      method: "POST",
      dataType: "json",
      data: {
        action,
        nonce: growtype_chat_ajax.nonce,
      },
      success(response) {
        if (!response?.success || !response?.data?.html) {
          reject(new Error("Inline content generator returned no HTML."));
          return;
        }

        placeholder.replaceWith(response.data.html);
        syncContentGeneratorPoseThumbnails($(document));
        resolve();
      },
      error() {
        reject(new Error("Inline content generator could not be loaded."));
      },
    });
  }).catch((error) => {
    inlineGeneratorPromise = null;
    throw error;
  });

  return inlineGeneratorPromise;
}

export class GenerateContent {
  static instance = null;

  constructor() {
    if (GenerateContent.instance) {
      return GenerateContent.instance;
    }

    this.$doc = $(document);
    this.NS = ".gencontent";

    this.$input = $(".g-chatform-text-input");
    this.$trigger = $(".g-chatform-quick-actions-grouped");
    this.$options = $(".g-chatform-quick-actions-grouped-options");

    this.cacheOriginalPlaceholder();
    this.registerGlobalCloseHelper();
    this.bindEvents();
    syncContentGeneratorPoseThumbnails($(document));
  }

  // ── Modal guard ────────────────────────────────────────────────

  isInsideModal($el) {
    return $el.closest(".content-generator-modal").length > 0;
  }

  // ── Input helpers ──────────────────────────────────────────────

  setInputCategory(type) {
    this.$input.attr({
      placeholder: `Enter ${type} details you want..`,
      "data-category": type,
    });
  }

  triggerSubmit() {
    this.$input.closest(".g-chatform").find(".btn-send").trigger("click");
  }

  // ── Setup ──────────────────────────────────────────────────────

  registerGlobalCloseHelper() {
    if (!window.growtypeChatCloseGenerateContent) {
      window.growtypeChatCloseGenerateContent = this.close.bind(this);
    }
  }

  cacheOriginalPlaceholder() {
    if (!this.$input.data("orig-placeholder")) {
      this.$input.data(
        "orig-placeholder",
        this.$input.attr("placeholder") || "Type a message"
      );
    }
  }

  // ── Open / Close ───────────────────────────────────────────────

  open() {
    this.$trigger.addClass("is-active").attr("aria-expanded", "true");
  }

  close() {
    this.$trigger.removeClass("is-active").attr("aria-expanded", "false");
  }

  resetInput() {
    const orig = this.$input.data("orig-placeholder") || "Type a message";
    this.$input.attr({ placeholder: orig, "data-category": "text" }).val("");

    $(".content-generator-settings-inner").slideUp();
    $(".g-chatform-btn-close-generate-content").remove();
    $("body").removeClass("generating-mode-active");

    updateChatFormInputHeight();
  }

  // ── Event bindings ─────────────────────────────────────────────

  bindEvents() {
    this.bindOutsideClick();
    this.bindTriggerClick();
    this.bindAdjustMemories();
    this.bindOptionsClick();
    this.bindCloseButton();
    this.bindContentNav();
    this.bindGroupItem();
    this.bindSpicyToggle();
    this.bindActionTrigger();
    this.bindKeyboard();
  }

  bindOutsideClick() {
    this.$doc.off("click" + this.NS).on("click" + this.NS, () => this.close());
  }

  bindTriggerClick() {
    this.$trigger.off("click" + this.NS).on("click" + this.NS, (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (this.$trigger.hasClass("is-active")) {
        this.close();
      } else {
        if (
          $(".g-chatform-footer-actions").hasClass("is-active") &&
          typeof window.growtypeChatCloseSampleActions === "function"
        ) {
          window.growtypeChatCloseSampleActions();
        }
        this.open();
      }
    });
  }

  bindAdjustMemories() {
    const $adjustMemories = this.$trigger.find(".g-chatform-adjust-memories");

    $adjustMemories
      .off("click" + this.NS)
      .on("click" + this.NS, (event) => {
        event.preventDefault();
        event.stopPropagation();

        this.close();
        if (!openSettingsModalTab("#memories-content")) {
          document.addEventListener(
            "growtypeChatSettingsModalLoaded",
            () => openSettingsModalTab("#memories-content"),
            { once: true }
          );
          $(".g-chat-btn-editchat, .btn-chat-settings").first().trigger("click");
        }
      })
      .off("keydown" + this.NS)
      .on("keydown" + this.NS, (event) => {
        if (event.key !== "Enter" && event.key !== " ") {
          return;
        }

        event.preventDefault();
        $adjustMemories.trigger("click");
      });
  }

  bindOptionsClick() {
    this.$options
      .off("click" + this.NS)
      .on("click" + this.NS, (e) => e.stopPropagation());
  }

  bindCloseButton() {
    this.$doc
      .off("mousedown" + this.NS, ".g-chatform-btn-close-generate-content")
      .on(
        "mousedown" + this.NS,
        ".g-chatform-btn-close-generate-content",
        (e) => {
          e.preventDefault();
        }
      );

    this.$doc
      .off("click" + this.NS, ".g-chatform-btn-close-generate-content")
      .on("click" + this.NS, ".g-chatform-btn-close-generate-content", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.resetInput();
        this.close();
        this.$input.focus();
      });
  }

  // ── Content UI ─────────────────────────────────────────────────

  bindContentNav() {
    this.$doc.on("click" + this.NS, ".content-generator-nav-item", (event) => {
      const $item = $(event.currentTarget);
      if (this.isInsideModal($item)) return;

      const type = $item.data("type");

      $(".content-generator-nav-item").removeClass("is-active");
      $item.addClass("is-active");

      $(".content-generator-pose-options-single")
        .removeClass("is-active")
        .filter(`[data-type="${type}"]`)
        .addClass("is-active");

      this.setInputCategory(type);
      this.$input.focus();
    });
  }

  bindGroupItem() {
    this.$doc.on(
      "click" + this.NS,
      ".content-generator-pose-options-single-item",
      (event) => {
        const $item = $(event.currentTarget);
        if (this.isInsideModal($item)) return;

        const promptData = $item.data("prompt") || "";
        const prompts = promptData.split("|");
        const prompt = prompts[Math.floor(Math.random() * prompts.length)];
        const type = $item.closest("[data-type]").data("type");

        this.setInputCategory(type);
        this.$input.val(prompt).focus();

        // if ($item.hasClass("instant-generate")) {
        //   this.triggerSubmit();
        // }
      }
    );
  }

  bindSpicyToggle() {
    this.$doc.on(
      "change" + this.NS,
      '.content-generator-settings-inner-actions input[name="nsfw_chat"], input[name="spicy_mode_is_active"]',
      (e) => {
        this.$input.attr("data-nsfw", e.target.checked);
        const $settings = $(e.currentTarget).closest(
          ".content-generator-settings-inner"
        );
        syncContentGeneratorPoseThumbnails(
          $settings.length ? $settings : $(document),
          e.target.checked
        );
      }
    );
  }

  bindActionTrigger() {
    $(".g-chatform-quick-action-trigger")
      .off("click" + this.NS)
      .on("click" + this.NS, (e) => {
        const $el = $(e.currentTarget);
        const action = $el.data("action");

        if (!action) return;

        e.preventDefault();
        e.stopPropagation();

        const activate = () => {
          const $activeNav = $(".content-generator-nav-item.is-active");
          const type = $activeNav.length
            ? $activeNav.data("type")
            : action || "image";

          this.setInputCategory(type);
          this.$input.val("").focus();

          $("body").addClass("generating-mode-active");
          this.close();
          this.ensureCloseButton();

          $(".content-generator-settings-inner").slideDown();
          window.growtypeChatCloseSampleActions();

          if (typeof growtypeAnalyticsCapture === "function") {
            growtypeAnalyticsCapture(
              "growtype_analytics_growtype_chat_action_clicked",
              { title: "generate_content", type: action }
            );
          }
        };

        const trigger = $(e.currentTarget);
        trigger.prop("disabled", true);
        ensureInlineGenerator()
          .then(activate)
          .catch((error) => console.error(error))
          .finally(() => trigger.prop("disabled", false));
      });
  }

  ensureCloseButton() {
    const $wrap = $(".g-chatform-footer-input-wrapper");
    const $actions = $(".content-generator-settings-inner");

    if ($wrap.find(".g-chatform-btn-close-generate-content").length === 0) {
      const $btn = $("<div>", {
        class: "g-chatform-btn-close-generate-content",
        role: "button",
        tabindex: 0,
        "aria-label": "Close",
      });

      $btn.clone(true).appendTo($wrap);
      $btn.appendTo($actions);
    }
  }

  bindKeyboard() {
    this.$doc.off("keydown" + this.NS).on("keydown" + this.NS, (e) => {
      if (e.key === "Escape") {
        this.close();
      }
    });
  }
}
